import React from 'react';
import Page from '../../layout/Page';
import Orders from './Orders';
import FulfillableProducts from '../fulfillment/Products';
import FulfilledOrders from './FulfilledOrders';

const Fulfillment = ({ ...props }) => {

    return (
        <Page
            title='Fulfillment'
            icon='scale'
            tabs
        >
            <FulfillableProducts tab='Fulfillment' />
            <Orders tab='Orders' />
            <FulfilledOrders tab='Fulfilled Orders' />
        </Page >
    );
}

export default Fulfillment;
